import React from "react";
import "./credit.scss";

function Credit() {
  return (
    <div className="credit">
      Website Designed & Developed By{" "}
      <b>
        <a href="https://arvnd.in" target="_blank" rel="noreferrer">
          Aravind
        </a>
      </b>
    </div>
  );
}

export default Credit;
